import controller from './detailed-payment.controller';
import template from './detailed-payment.view.html';

let DetailedPaymentComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DetailedPaymentComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/pay-zone/detailed-payment/detailed-payment.component.js
 **/